import React from "react"

import { OneVerifyEraUploadFileFormat } from "@common-shared/config/oneVerify/oneVerifyIntegrations.config"
import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { PopupWrapperElement } from "@front-shared/elements/popupWrapper.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"
import type { IPopupProps } from "@front-shared/types/props.types"

import { INTEGRATIONS_CONFIG } from "../../config/integrations.config"
import type { IEraUploadFileReviewState } from "../../types/integrations.types"
import { EraUploadFileDropzoneComponent } from "../integrations/eraUpload/eraUploadFileDropzone.component"

export const EraUploadBulkUploadPopupComponent: React.FunctionComponent<
    IEraUploadBulkUploadPopupComponentProps
> = props => {
    const isCsvFormat = props.fileFormat === OneVerifyEraUploadFileFormat.csv

    const isReplaceMode = props.mode === "replace"

    const title = isReplaceMode ? "Replace ERA file" : "Add ERA files"

    const description = isReplaceMode
        ? isCsvFormat
            ? "Choose a CSV file that matches the ERA upload template."
            : `Choose an X12 835 file with ${INTEGRATIONS_CONFIG.eraUpload.requiredX12SegmentsLabel} segments.`
        : isCsvFormat
          ? "CSV files must match the ERA upload template."
          : `X12 835 files must include ${INTEGRATIONS_CONFIG.eraUpload.requiredX12SegmentsLabel} segments.`

    return (
        <PopupWrapperElement
            isActive={props.isActive}
            className={props.className}
            onDone={props.onDone}
            closeOnOutsideClick={props.closeOnOutsideClick}
            popupWidthClassName="!w-[560px] !bg-brand-white"
            withCloseIcon={true}
        >
            <div className="pt-[8px]">
                <PrimaryText
                    typography="h5"
                    color={NIRVANA_COLORS.brand.black}
                    className="mb-[8px]"
                >
                    {title}
                </PrimaryText>

                <PrimaryText
                    typography="subtitle"
                    color={NIRVANA_COLORS.brand.warmShadow}
                    className="mb-[16px]"
                >
                    {description}
                </PrimaryText>

                {props.isActive ? (
                    <EraUploadFileDropzoneComponent
                        acceptedFileFormat={props.fileFormat}
                        maxFiles={props.maxFiles}
                        singleFileOnly={props.singleFileOnly}
                        onFilesValidated={files => {
                            props.onFilesValidated(files)

                            props.onDone()
                        }}
                    />
                ) : null}
            </div>
        </PopupWrapperElement>
    )
}

interface IEraUploadBulkUploadPopupComponentProps extends IPopupProps {
    mode: "add" | "replace"
    fileFormat: OneVerifyEraUploadFileFormat
    maxFiles?: number
    singleFileOnly?: boolean
    onFilesValidated: (files: IEraUploadFileReviewState[]) => void
}
